import { ref } from "vue";

import { DateUtils } from "@/utils/dateUtils";

import { useDate } from "vuetify";

import { ExecutionService } from "@/services";

import { isLoading } from "@/shared/base.service";

import type { Execution } from "@/types/model/execution";

import type { Pagination } from "@/types/props/pagination";
import { ExecutionParams } from "@/types/request/getExecution";

export function useExecution() {
  const execution = ref<Execution>();
  const executions = ref<Execution[]>([]);

  const date = useDate();

  const columns = ref<object[]>([
    // { title: "ID", align: "start", key: "id" },
    { title: "Nome", align: "start", key: "integration_name" },
    {
      title: "Data e Hora da Execução",
      align: "center",
      key: "executed_at",
      value: (item: Execution) =>
        item?.execution_datetime
          ? date.format(item.execution_datetime, "keyboardDateTime")
          : "-",
    },
    {
      title: "Conector de Entrada",
      align: "center",
      key: "connector_in",
      value: (item: Execution) => item.connector_in_name,
    },
    {
      title: "Conector de Saída",
      align: "center",
      key: "connector_out",
      value: (item: Execution) => item.connector_out_name,
    },
    {
      title: "Registros Integrados",
      align: "center",
      key: "lines_processed",
    },
    {
      title: "Status",
      align: "center",
      key: "status",
    },
  ]);

  const pagination = ref<Pagination>({
    current_page: 1,
    total_items: 0,
    total_pages: 0,
    page: 1,
    size: 10,
    sort: [],
  });

  async function getExecutions(params: ExecutionParams
  ) {
    try {
      const now = new Date();
      const yesterday = new Date(now);
      yesterday.setDate(now.getDate() - 1);

      const initialDate = params.initial_datetime
        ? params.initial_datetime
        : DateUtils.formatDate(yesterday);

      const finalDate = params.final_datetime
        ? params.final_datetime
        : DateUtils.formatDate(now);

        const payload = {
          ...params,
          initial_datetime: initialDate,
          final_datetime: finalDate
        }

      const response = await ExecutionService.GetExecutions(payload);

      if (response) {
        executions.value = response.data;

        pagination.value = {
          size: payload.size,
          page: payload.page,
          total_items: response.total_items,
          total_pages: response.total_pages,
          current_page: response.current_page + 1, // Adicionado parâmetro + 1 porque retorno de current_page inicia com 0,
        };
      }
    } catch (error) {
      console.error(error);
    }
  }

  return {
    isLoading,
    columns,
    pagination,
    execution,
    executions,
    getExecutions,
  };
}
